// 1:1 port of customer-apps/member-application/models/registration-step.ts.
// The titles are `$localize` strings in Angular, so they are looked up at render time here — the
// step objects themselves stay plain constants and are compared by identity (as in Angular).
export interface RegistrationStep {
    path: string
    /** German source text; run through `$t()` where it is rendered. */
    title: string
    showNextButton: boolean
    showBackButton: boolean
    showInReview: boolean | 'payerOnly'
}

export const registrationStepMemberBaseData: RegistrationStep = {
    path: 'add-members',
    title: 'Person',
    showNextButton: true,
    showBackButton: true,
    showInReview: true,
};

export const registrationStepMemberExtendedData: RegistrationStep = {
    path: 'members-data',
    title: 'Kontakt',
    showNextButton: true,
    showBackButton: true,
    showInReview: true,
};

export const registrationStepDepartments: RegistrationStep = {
    path: 'departments',
    title: 'Abteilungen',
    showNextButton: true,
    showBackButton: true,
    showInReview: true,
};

export const registrationStepPaymentDetails: RegistrationStep = {
    path: 'payment-details',
    title: 'Zahlungsdaten',
    showNextButton: true,
    showBackButton: true,
    showInReview: 'payerOnly',
};

export const registrationStepAdditionalInformation: RegistrationStep = {
    path: 'additional-information',
    title: 'Weitere Informationen',
    showNextButton: true,
    showBackButton: true,
    showInReview: true,
};

export const registrationStepFileUploads: RegistrationStep = {
    path: 'file-upload',
    title: 'Dateiuploads',
    showNextButton: true,
    showBackButton: true,
    showInReview: true,
};

export const registrationStepReview: RegistrationStep = {
    path: 'review',
    title: 'Zusammenfassung',
    showNextButton: false,
    showBackButton: true,
    showInReview: false,
};

export const registrationStepDone: RegistrationStep = {
    path: 'done',
    title: 'Geschafft',
    showNextButton: false,
    showBackButton: false,
    showInReview: false,
};
